import type { Order } from '@/types';
import { getEffectiveOrderTime } from '@/utils/orderTime';

interface ReviewHeaderProps {
  order: Order | null;
  className?: string;
}

export function ReviewHeader({ order, className = '' }: ReviewHeaderProps) {
  
  if (!order) {
    return null;
  }

  return (
    <div className={`text-center mb-8 ${className}`}>
      <h1 className="text-[28px] font-bold text-[#222222] mb-4">리뷰 작성</h1>
      <p className="text-[16px] text-gray-600 mb-6">
        주문하신 음식은 어떠셨나요?<br />
        솔직한 후기를 남겨주세요
      </p>
      
      {/* 주문 정보 */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 max-w-md mx-auto">
        <div className="text-left space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-[14px] text-gray-600">매장</span>
            <span className="text-[14px] font-medium text-[#222222]">
              {order.restaurant?.name || '매장명 없음'}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-[14px] text-gray-600">주문일시</span>
            <span className="text-[14px] font-medium text-[#222222]">
              {new Date(getEffectiveOrderTime(order) || order.created_at).toLocaleDateString('ko-KR', {
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-[14px] text-gray-600">주문금액</span>
            <span className="text-[14px] font-medium text-green-600">
              {order.total_amount?.toLocaleString()}원
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
